module.exports = __webpack_public_path__ + "static/media/alex.f6c586ab.png";